export default __webpack_public_path__ + "static/media/RFitness.a79030c7.svg";